export const ChatIcon = () => {
    return (

        <svg width="700pt" height="700pt" version="1.1" viewBox="0 0 700 700">
            <g>
                <path d="m521.76 153.41c0-29.125-11.578-57.059-32.184-77.645-20.602-20.586-48.547-32.141-77.672-32.117h-194.46c-29.125 0.007813-57.055 11.586-77.641 32.188-20.586 20.602-32.145 48.539-32.129 77.664v83.086c-0.027344 28.852 11.312 56.555 31.566 77.105 20.25 20.551 47.781 32.297 76.629 32.695 4.2656 0.050782 7.6953 3.5234 7.6953 7.7891h0.035156v80.551l85.59-86.051c1.4609-1.4688 3.4531-2.2969 5.5273-2.2969h97.273c29.109 0 57.027-11.562 77.609-32.145 20.586-20.586 32.148-48.504 32.148-77.613v-83.211zm-149.29 14.402h46.641v54.461h-54.461v-54.461zm31.012 15.629v23.203h-23.195v-23.203zm-105.38-15.629h46.641v54.461h-54.457v-54.461zm31.012 15.629v23.203h-23.195v-23.203zm-110.98-15.629h46.641v54.461h-54.457v-54.461zm31.008 15.629v23.203h-23.195v-23.203zm38.781 249.12v0.003906c-2.1797 0.16406-4.3242-0.58594-5.9258-2.0703-1.5977-1.4844-2.5078-3.5664-2.5078-5.75 0-2.1797 0.91016-4.2656 2.5078-5.75 1.6016-1.4805 3.7461-2.2305 5.9258-2.0664h97.188c2.2852-0.003906 4.457 0.99609 5.9414 2.7383l85.227 85.68 0.085938-80.613h-0.003907c-0.003906-4.2656 3.4297-7.7383 7.6953-7.7812 28.855-0.39453 56.398-12.133 76.664-32.684 20.262-20.547 31.617-48.25 31.605-77.109v-83.359c0.007813-19.82-5.3516-39.277-15.512-56.301-10.156-17.02-24.738-30.973-42.191-40.375 1.8477 8.6328 2.7734 17.438 2.7695 26.27v83.191c0 33.262-13.215 65.16-36.73 88.676-23.52 23.52-55.418 36.73-88.676 36.73h-94.078l-96.188 96.723c-2.1406 2.4648-5.5781 3.3438-8.6367 2.2148-3.0586-1.1289-5.0977-4.0312-5.125-7.293v-92.012c-31.527-2.3828-60.992-16.594-82.488-39.777-21.496-23.188-33.438-53.641-33.43-85.262v-83.086c0.007812-33.266 13.219-65.164 36.73-88.695 23.516-23.531 55.406-36.766 88.668-36.801h194.46c25.129 0.023438 49.676 7.5781 70.473 21.688 20.797 14.113 36.887 34.129 46.191 57.473 23.406 9.2383 43.492 25.297 57.652 46.098 14.16 20.801 21.734 45.379 21.746 70.539v83.359c-0.015625 31.629-11.98 62.086-33.5 85.27-21.516 23.184-50.996 37.383-82.539 39.754l-0.089843 91.688c0.14062 3.2188-1.7109 6.1914-4.6602 7.4805-2.9453 1.293-6.3867 0.64062-8.6562-1.6445l-96.598-97.141z" fillRule="evenodd" />
                <use x="70" y="644" />
                <use x="90.550781" y="644" />
                <use x="104.359375" y="644" />
                <use x="123.347656" y="644" />
                <use x="142.242188" y="644" />
                <use x="155.628906" y="644" />
                <use x="174.617188" y="644" />
                <use x="204.410156" y="644" />
                <use x="224.453125" y="644" />
                <use x="252.453125" y="644" />
                <use x="272.382812" y="644" />
                <use x="292.429688" y="644" />
                <use x="70" y="672" />
                <use x="82.183594" y="672" />
                <use x="95.992188" y="672" />
                <use x="115.226562" y="672" />
                <use x="154.152344" y="672" />
                <use x="167.535156" y="672" />
                <use x="187.46875" y="672" />
                <use x="216.207031" y="672" />
                <use x="239.640625" y="672" />
                <use x="258.878906" y="672" />
                <use x="278.8125" y="672" />
                <use x="308.492188" y="672" />
                <use x="329.015625" y="672" />
                <use x="342.820312" y="672" />
                <use x="362.058594" y="672" />
                <use x="371.65625" y="672" />
                <use x="390.648438" y="672" />
                <use x="407.242188" y="672" />
            </g>
        </svg>


    )
}

export const RaiseQueryIcon = () => {
    return (
        <svg width="700pt" height="700pt" version="1.1" viewBox="0 0 700 700" >
            <g>
                <path d="m235.14 456.39 12.133 6.8242c30.336 17.051 65.34 26.789 102.73 26.789 115.98 0 210-94.02 210-210s-94.02-210-210-210-210 94.02-210 210c0 37.387 9.7383 72.391 26.789 102.73l6.8242 12.133-20.512 82.039zm-130.14 68.613 31.281-125.12c-19.922-35.438-31.281-76.328-31.281-119.88 0-135.31 109.69-245 245-245s245 109.69 245 245-109.69 245-245 245c-43.547 0-84.438-11.359-119.88-31.281z" fillRule="evenodd" />
                <path d="m367.44 285.38c-7.7422 3.25-15.516 6.5156-21.375 12.48-7.5625 7.7031-11.812 18.152-11.812 29.047v23.09h31.5v-20.574c0-7.6289 5.3555-14.043 12.352-16.766 29.613-11.527 50.648-40.738 50.648-74.953 0-44.297-35.258-80.207-78.75-80.207-38.23 0-71.598 27.363-78.75 64.168l31.5 8.0195c3.6836-22.84 23.781-40.105 47.25-40.105 26.098 0 47.25 21.547 47.25 48.125 0 20.34-7.7734 37.73-23.121 44.777-2.1953 1.0078-4.4414 1.9531-6.6914 2.8984z" />
                <path d="m332.5 367.5h35v35h-35z" />
            </g>
        </svg>

    )
}

export const CallBackIcon = () => {
    return (
        <svg width="700pt" height="700pt" version="1.1" viewBox="0 0 700 700"  >
            <g>
                <path d="m439.12 355.36-32.121-34.586c-3.5664-3.8477-9.5703-4.0703-13.41-0.5l-12.488 11.586c-0.875-1.8086-1.9375-3.5781-3.2383-5.2461 0 0-29.719-30.055-38.328-41.082-8.5977-11.031-30.535-47.164-30.535-47.164-0.58984-0.77344-1.2383-1.4961-1.8828-2.1836 1.9805 0.16797 4.0273-0.25391 5.8398-1.3945l14.699-9.2578c4.4297-2.793 5.7617-8.6562 2.9727-13.094l-25.156-39.938c-2.7891-4.4336-8.6523-5.7695-13.082-2.9805l-14.711 9.2578c-1.1719 0.73828-2.1094 1.7031-2.832 2.7891l-6.0352 4.3867c-11.316 8.2031-12.621 19.453-7.8516 34.988 0 0 11.121 34.223 42.09 76.906 29.695 40.953 53.82 67 76.574 84.035 13.277 9.9336 24.051 13.844 35.359 5.6289l6.3438-4.5977c1.6523-0.33594 3.2383-1.082 4.5586-2.3125l12.73-11.82c3.8555-3.5781 4.0742-9.582 0.50391-13.422z" />
                <path d="m278.99 415.84c-51.078-26.359-82.816-78.41-82.816-135.84 0-81.711 64.488-148.64 145.24-152.57l-0.023437 33.906 51.043-45.254-50.98-45.344-0.027344 34.289c-93.105 3.9453-167.65 80.898-167.65 174.97 0 65.852 36.379 125.54 94.941 155.75 1.6406 0.84375 3.3945 1.25 5.125 1.25 4.0586 0 7.9727-2.2109 9.9609-6.0664 2.8477-5.5 0.68359-12.258-4.8125-15.094z" />
                <path d="m526.23 280c0-65.402-36.02-124.89-93.996-155.25-5.4805-2.8711-12.246-0.75781-15.113 4.7266-2.8672 5.4805-0.75781 12.246 4.7266 15.113 50.566 26.488 81.988 78.379 81.988 135.41 0 81.711-64.488 148.64-145.24 152.57l0.023437-33.914-51.043 45.258 50.98 45.344 0.027344-34.289c93.102-3.9453 167.65-80.906 167.65-174.97z" />
                <use x="70" y="644" />
                <use x="90.550781" y="644" />
                <use x="104.359375" y="644" />
                <use x="123.347656" y="644" />
                <use x="142.242188" y="644" />
                <use x="155.628906" y="644" />
                <use x="174.617188" y="644" />
                <use x="204.410156" y="644" />
                <use x="224.453125" y="644" />
                <use x="252.453125" y="644" />
                <use x="272.382812" y="644" />
                <use x="291.621094" y="644" />
                <use x="311.664062" y="644" />
                <use x="321.261719" y="644" />
                <use x="339.320312" y="644" />
                <use x="358.3125" y="644" />
                <use x="70" y="672" />
                <use x="82.183594" y="672" />
                <use x="95.992188" y="672" />
                <use x="115.226562" y="672" />
                <use x="154.152344" y="672" />
                <use x="167.535156" y="672" />
                <use x="187.46875" y="672" />
                <use x="216.207031" y="672" />
                <use x="239.640625" y="672" />
                <use x="258.878906" y="672" />
                <use x="278.8125" y="672" />
                <use x="308.492188" y="672" />
                <use x="329.015625" y="672" />
                <use x="342.820312" y="672" />
                <use x="362.058594" y="672" />
                <use x="371.65625" y="672" />
                <use x="390.648438" y="672" />
                <use x="407.242188" y="672" />
            </g>
        </svg>

    )
}